import surveyQuestionApi from '../../../services/api/surveys/surveyQuestionApi'
import surveyItemApi from '../../../services/api/surveys/surveyItemApi'
import {isSkipLogicBuilderEnabled} from '../../../utils/skipLogicBuilderAccess'
import {mergeSurveyItems} from '../../../utils/surveyItems'

// The builder's ordered list. Behind the flag it merges the server's item list
// (ordered, carrying content/rules) with the full questions (text, options) -
// the item list holds only a questionId for questions, so question rows are
// filled in from the questions endpoint. Falls back to the question-only list
// when the flag is off, no survey id is known yet, or the item endpoint is not
// available.
export const loadBuilderItems = async (surveyId, token) => {
  if (isSkipLogicBuilderEnabled() && surveyId != null) {
    try {
      const [items, questions] = await Promise.all([
        surveyItemApi.getItemsBySurveyId(surveyId),
        surveyQuestionApi.getByToken(token),
      ])
      if (Array.isArray(items)) {
        return mergeSurveyItems(items, questions)
      }
    } catch (e) {
      // Not deployed yet or failed: the question-only endpoint below still works.
    }
  }
  const questions = await surveyQuestionApi.getByToken(token)
  return Array.isArray(questions) ? questions : []
}

export default loadBuilderItems
